import { Button, type IButtonProps } from '~/components/button'

type ButtonBarCodeProps = Omit<IButtonProps, 'children'> & {
  testID?: string
}

export function ButtonBarCode(props: ButtonBarCodeProps) {
  return (
    <Button.Root
      {...props}
      size={props.size || 'md'}
      variant="neutral-tertiary"
    >
      <Button.Icon symbol="rdicon-barcode-scan-variant" />
    </Button.Root>
  )
}
